export default __webpack_public_path__ + "static/media/Arrow-footer-803cb6cdb9cba29961d5216f1b28e51e.png";